<template>
    <div class="wrap">
        <div class="head">
            <div id="headBgc">
                <div class="headtop newtheme-mw1200 newtheme-topheight">
                    <div>
                        <Logo></Logo>
                    </div>
                    <div class="newtheme-headinfo">
                        <span style="display:inline-block;margin-right:40px;">
                            &nbsp;&nbsp;您好,
                            <span class="uName" @click="goSetting()">
                                {{ appUtils.getUserInfo().x_realName ? appUtils.getUserInfo().x_realName : '请登录' }}
                            </span>
                        </span>
                        <span @click="byebye" style="cursor:pointer;display:inline-block;padding: 0 10px;"
                            class="newtheme-columnLine">
                            退出
                        </span>
                        <span style="display:inline-block;padding: 0 10px;cursor: pointer;" @click="gosdManager()">
                            综合管理平台
                        </span>
                    </div>
                </div>
            </div>
            <div class="headmainwrap" id="headmainwrap">
                <div class="clwhite newtheme-headmain mw1200">
                    <div class="newtheme-changeColor">
                        <template v-if="theme === 'blue'">
                            <img style="vertical-align:middle" src="@/assets/newlogo.png" alt="">
                            <span>&nbsp;个人学习中心</span>
                        </template>
                        <template v-else>
                            <i class="wrapwhite clred el-icon-s-custom"></i>
                            <span>&nbsp;&nbsp;个人中心</span>
                        </template>
                        <template v-if="theme != 'blue' && personalMode === 1">
                            <span></span>
                            <span v-for="item in menuData" :key="item.path" @click="handleRouteChange(item)"
                                :class="{ on: activeRulesMap[item.path] && activeRulesMap[item.path].includes($route.path) }">
                                {{ item.tenantMenuName }}
                            </span>
                        </template>
                    </div>
                    <div class="headmainbtn" v-if="theme == 'blue'">
                        <ul class="topTabs">
                            <li v-for="item in menuData" :key="item.path" @click="handleRouteChange(item)"
                                :class="{ 'activeBlue': $route.path === item.path }">
                                {{ item.tenantMenuName }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="kefuPhone">
                        <i class="clwhite el-icon-phone-outline"
                            style="font-size: 20px;border: 1px solid white;border-radius: 50%;height: 40px;width: 40px;vertical-align: middle;line-height: 40px;">
                        </i>
                        &nbsp;&nbsp;
                        <div style="display:inline-block;vertical-align:middle;font-size:14px;line-height: 22px;">
                            <span style="font-size:14px;">教育服务热线</span>
                            <br>
                            <span style="font-size:12px;">{{ kefuPhone }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="informBox" v-if="informData.length > 0">
            <div class="information">
                <img id="informImg" src="../../../static/images/noise.png" alt="">
                <span class="oneInform" v-for="(fd, idx) in informData" ref="oneArticle" :key="idx"
                    @click="goArticle(fd.bulId)">{{ fd.topic }}</span><!--v-model="fd.bulId" -->
                <span class="formRight" @click="goMessage()">查看更多&gt;&gt;</span>
            </div>
        </div>
        <div class="viewArea">
            <router-view ref="sideTab"></router-view>
        </div>
        <div class="footer">
            <div v-html="loginFooter"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Logo from '../../components/Logo';

export default {
    name: 'HelloWorld',
    components: {
        Logo
    },
    computed: {
        ...mapState({
            personalMode: state => state.menuConfig.personalMode,
            menuData: state => state.menuConfig.menuData,
            activeRulesMap: state => state.menuConfig.activeRulesMap,
        })
    },
    watch: {
        personalMode() {
            // 区平台模式
            // if (this.personalMode === 1 && this.$route.path == '/') {
            //     this.$router.push({ ...this.$route, path: "/indexhd" })
            // }
        },
    },
    data() {
        return {
            theme: this.appUtils.getAPPInfo().styleUsercentor,
            informData: [],
            kefuPhone: this.appUtils.getKefuPhone(),
            loginFooter: this.appUtils.getAppId() == 'APPY317' ? 'Copyright ©  2022  河南精微教育科技有限公司   版权所有   豫ICP备2022012049号-1' : this.appUtils.getLoginFooter(),
        }
    },
    mounted() {
        this.getAppInfo();
    },
    created() {
        this.getArticle();
    },
    methods: {
        ...mapActions('menuConfig', ['getMenuConfig']),
        ...mapActions('listApply', ['getListApplyUnaudited', 'getSubjectChangeUnaudited']),
        handleRouteChange({ path }) {
            if (path === '/empty') {
                this.$message({
                    type: "info",
                    message: "功能正在建设中",
                });
                return;
            }
            this.$router.push(path);
        },
        updateData() {
            this.getMenuConfig(this.$route);
            const isSchoolManager =
                this.appUtils.getUserInfo().x_isSchoolManager == "Y";
            if (isSchoolManager) {
                this.getListApplyUnaudited();
                this.getSubjectChangeUnaudited();
            }
            this.theme = this.appUtils.getAPPInfo().styleUsercentor;
            this.kefuPhone = this.appUtils.getKefuPhone();
            this.loginFooter = this.appUtils.getAppId() == 'APPY317' ? 'Copyright ©  2022  河南精微教育科技有限公司   版权所有   豫ICP备2022012049号-1' : this.appUtils.getLoginFooter();
        },
        getAppInfo() {
            this.axios.post(this.apis.home.baseServer + '/app-info/search', {
                where: {
                    //   domain_like: 'http://shxy.p.test.gdteacher.com/'
                    domain_like: window.location.host
                    //   domain_like: 'http://172.16.146.184'
                    //   domain_like: 'http://api.dev.gdteacher.com'
                }
            }, false, false).then(res => {
                if (res.data.data && res.data.data.length > 0) {
                    this.appUtils.setLocalStorage(this.constyjyp.APPINFO, res.data.data[0]);
                    if (this.appUtils.getAPPInfo().styleUsercentor == 'blue') {
                        // 方法一，c3全局变量,缺点：一开始加载了默认样式，然后再变化样式
                        document.documentElement.style.setProperty("--theme_white_brown", "#3C64B1");/*最上方背景颜色*/
                        document.documentElement.style.setProperty("--theme_red_white1", "white");/*头部学员个人中心背景颜色*/
                        document.documentElement.style.setProperty("--theme_white_blue1", "#3C64B1");/*白色文字变蓝色文字，如（学员个人中心）*/
                        document.documentElement.style.setProperty("--theme_white_blue2", "#3C64B1");/*首页头像后的颜色*/
                        document.documentElement.style.setProperty("--theme_white_blue3", "rgb(60,100,177,.71");/*首页头像后的颜色*/
                        document.documentElement.style.setProperty("--theme_ccc_white", "white");/*首页，参训项目背景颜色*/
                        document.documentElement.style.setProperty("--theme_gray_white2", "white");/*灰色背景变白色，如正在参训的项目背景*/
                        document.documentElement.style.setProperty("--theme_red_blue1", "#3C64B1");/* 红变蓝,文字和logo颜色=======》常用*/
                        document.documentElement.style.setProperty("--theme_red_blue2", "#3C64B1");/*红变蓝，小方块颜色*/
                        document.documentElement.style.setProperty("--theme_red_blue3", "#3C64B1");//按钮颜色
                        document.documentElement.style.setProperty("--theme_red_blue4", "#4F73B8");//按钮hover颜色
                        document.documentElement.style.setProperty("--theme_pink_blue", "rgba(29, 158, 215,.1)");//列表的hover效果(首页暂未设置)
                        document.documentElement.style.setProperty("--theme_orange_blue", "rgba(29, 158, 215,.8)");// 表单必填颜色
                        // 方法二，动态加载css
                        let link = document.createElement('link');
                        link.type = 'text/css';
                        link.id = "new-theme";
                        link.rel = 'stylesheet';
                        link.href = './static/css/newtheme.css';
                        document.getElementsByTagName('head')[0].appendChild(link);
                        this.theme = this.appUtils.getAPPInfo().styleUsercentor;
                    }
                } else {
                    if (this.appUtils.getAPPInfo().styleUsercentor == 'blue') {
                        // 方法一，c3全局变量
                        document.documentElement.style.setProperty("--theme_white_brown", "#3C64B1");/*最上方背景颜色*/
                        document.documentElement.style.setProperty("--theme_red_white1", "white");/*头部学员个人中心背景颜色*/
                        document.documentElement.style.setProperty("--theme_white_blue1", "#3C64B1");/*白色文字变蓝色文字，如（学员个人中心）*/
                        document.documentElement.style.setProperty("--theme_white_blue2", "#3C64B1");/*首页头像后的颜色*/
                        document.documentElement.style.setProperty("--theme_white_blue3", "rgb(60,100,177,.71");/*首页头像后的颜色*/
                        document.documentElement.style.setProperty("--theme_ccc_white", "white");/*首页，参训项目背景颜色*/
                        document.documentElement.style.setProperty("--theme_gray_white2", "white");/*灰色背景变白色，如正在参训的项目背景*/
                        document.documentElement.style.setProperty("--theme_red_blue1", "#3C64B1");/* 红变蓝,文字和logo颜色=======》常用*/
                        document.documentElement.style.setProperty("--theme_red_blue2", "#3C64B1");/*红变蓝，小方块颜色*/
                        document.documentElement.style.setProperty("--theme_red_blue3", "#3C64B1");//按钮颜色
                        document.documentElement.style.setProperty("--theme_red_blue4", "#4F73B8");//按钮hover颜色
                        document.documentElement.style.setProperty("--theme_pink_blue", "rgba(29, 158, 215,.1)");//列表的hover效果(首页暂未设置)
                        document.documentElement.style.setProperty("--theme_orange_blue", "rgba(29, 158, 215,.8)");// 表单必填颜色
                        // 方法二，动态加载css
                        let link = document.createElement('link');
                        link.type = 'text/css';
                        link.id = "new-theme";
                        link.rel = 'stylesheet';
                        link.href = './static/css/newtheme.css';
                        document.getElementsByTagName('head')[0].appendChild(link);
                        this.theme = this.appUtils.getAPPInfo().styleUsercentor;
                    }
                }
                // 更新 data 中的数据
                this.updateData();
            }).catch(err => {
                console.log(err);
            });
        },
        byebye() {
            this.appUtils.removeLocalStorage(this.constyjyp.USER_INFO);
            this.appUtils.removeLocalStorage(this.constyjyp.TOKEN_KEY);
            this.$router.push({ path: "/login" })
        },
        getArticle() {
            let url = this.apis.home.proServer + '/bulletin/page-search';
            let nowDate = this.appUtils.getDatetime();
            this.axios.post(url, {
                where: {
                    type_eq: 1,
                    appId_eq: this.appUtils.getAppId(),
                    startDt_le: nowDate,
                    endDt_ge: nowDate
                }
            })
                .then((res) => {
                    this.informData = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
        },
        goMessage() {
            this.$router.push({ path: '/message' });
        },
        goArticle(bulId) {
            let linkUrl = this.appUtils.getLMSDomain()
            if (linkUrl.indexOf("/gl") == -1) {
                linkUrl = linkUrl + "/gl"
            }
            window.open(linkUrl + this.apis.home.getNoticedetail + "?bulId=" + bulId);
        },
        goSetting() {
            this.$router.push({ path: '/setting' });
        },
        gosdManager() {
            window.open(this.appUtils.getLMSDomain());
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.activeBlue {
    color: #3C64B1;
}

.viewArea {
    min-height: calc(100vh - 267px);
}

.wrapwhite {
    background: white;
    // background: var(--theme_blue);
    border-radius: 50%;
    height: 30px;
    width: 30px;
    display: inline-block;
    vertical-align: middle;
    /* margin-right: 3px; */
}

.uName {
    cursor: pointer;
}

.wrapwhite:before {
    line-height: 30px;
}

.wrapwhite1 {
    /* background: white; */
    border-radius: 50%;
    height: 30px;
    width: 30px;
    display: inline-block;
    vertical-align: middle;
    /* margin-right: 3px; */
}

.wrapwhite1:before {
    line-height: 30px;
}

.clwhite {
    color: white;
    line-height: 30px;
    /* cursor: pointer; */
}

.clred {
    // color: rgba(190, 28, 33, 1);
    color: var(--theme_red_blue1);
    border: 1px solid #3C64B1;
}

.topTabs {
    display: flex;
    list-style-type: none;
    color: #666666;
    margin-left: -80px;
}

.topTabs li {
    margin-right: 20px;
    font-size: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    cursor: pointer;
    width: 100px;
}

.cp {
    cursor: pointer;
}

.active {
    background: #B40410;
}

.clgreen {
    color: green;
}

.mw1200 {
    max-width: 1200px;
    margin: auto;
}

.newtheme-mw1200 {
    max-width: 1200px;
    margin: auto;
}

#headBgc {
    // background-color: #fff;
    background-color: var(--theme_white_brown);
}

.headtop {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    // background-color: white;
}

.newtheme-headinfo {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 5px 0;
    color: var(--theme_ccc_white);
    font-size: 14px;
}

.newtheme-columnLine {
    border-right: 1px solid #616161;
}

.newtheme-changeColor {
    color: var(--theme_white_blue1);
    font-size: 18px;
    height: 100%;
    line-height: 89px;

    span {
        display: inline-block;
        padding: 0 15px;
        cursor: pointer;
        text-align: center;
        min-width: 80px;
    }

    .on {
        background-color: #ec4444;
    }
}

.newtheme-headmain {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    height: 89px;
}

.headmainbtn {
    display: flex;
    flex-flow: row nowrap;
}

.headmainbtn span {
    display: inline-block;
    box-sizing: border-box;
    padding: 14px 0;
    width: 110px;
    text-align: center;
    color: white;
    border-right: 1px solid rgba(225, 38, 43, 1);
}

.headmainbtn span:nth-of-type(1) {
    border-left: 1px solid rgba(225, 38, 43, 1);
}

.headmainwrap {
    // background-color: rgba(190, 28, 33, 1);
    background-color: var(--theme_red_white1)
}

.footer {
    background-color: rgba(97, 97, 97, 1);
    text-align: center;
    font-weight: 400;
    color: white;
    line-height: 26px;
    padding: 23.5px 0;
    font-size: 14px;
}

.informBox {
    width: 100%;
    background: #fff;
}

.information {
    background-color: #fffac6;
    height: 24px;
    line-height: 24px;
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    position: relative;
    font-size: 14px;
    overflow: hidden;

    .oneInform {
        float: left;
        // display: inline-block;
        width: 40%;
        text-align: left;
        padding-left: 20px;
        margin-left: 20px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .formRight {
        margin-right: 20px;
        cursor: pointer;
        color: rgb(242, 123, 36);
        position: absolute;
        top: 0;
        right: 10px;
    }
}

#informImg {
    position: absolute;
    width: 16px;
    height: 15px;
    top: 4px;
    left: 6px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wrap/index.vue